import axios from 'axios';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import Swal from 'sweetalert2';




const RegistrarJefes = () => {
    const { id } = useParams();

    // Información básica del Jefe
    const [documentoJefe, setDocumentoJefe] = useState('');
    const [tipodocumentoJefe, setTipodocumentoJefe] = useState('');
    const [nombre1Jefe, setNombre1Jefe] = useState('');
    const [nombre2Jefe, setNombre2Jefe] = useState('');
    const [apellido1Jefe, setApellido1Jefe] = useState('');
    const [apellido2Jefe, setApellido2Jefe] = useState('');
    const [emailJefe, setEmailJefe] = useState('');

    // Información de contacto
    const [telefono1Jefe, setTelefono1Jefe] = useState('');
    const [telefono2Jefe, setTelefono2Jefe] = useState('');

    const [edit, setEdit] = useState(false);

    useEffect(() => {
        setEdit(!!id);
    }, [id]);

    const getData = async () => {
        try {
            const { data } = await axios.get(`/api/jefe/listid/${id}`);
            if (data.ok) {
                const jefe = data.message;
                setNombre1Jefe(jefe.nombre1Jefe || '');
                setNombre2Jefe(jefe.nombre2Jefe || '');
                setApellido1Jefe(jefe.apellido1Jefe || '');
                setApellido2Jefe(jefe.apellido2Jefe || '');
                setTipodocumentoJefe(jefe.tipodocumentoJefe || '');
                setDocumentoJefe(jefe.documentoJefe || '');
                setTelefono1Jefe(jefe.telefono1Jefe || '');
                setEmailJefe(jefe.emailJefe || '');
            }
        } catch (error) {
            console.error('Error al obtener el jefe:', error.message);
        }

    };

    useEffect(() => {
        if (id) {
            getData();
        }
        // eslint-disable-next-line
    }, [id]);

    const cleanData = () => {

        setDocumentoJefe('');
        setTipodocumentoJefe('');
        setNombre1Jefe('');
        setNombre2Jefe('');
        setApellido1Jefe('');
        setApellido2Jefe('');
        setEmailJefe('');
        setTelefono1Jefe('');
        setTelefono2Jefe('');

    };

    const saveJefe = async () => {
        try {
            const newJefe = {
                documentoJefe,
                tipodocumentoJefe,
                nombre1Jefe,
                nombre2Jefe,
                apellido1Jefe,
                apellido2Jefe,
                emailJefe,
                telefono1Jefe,
                telefono2Jefe,
            };

            await axios.post('/api/jefe/add', newJefe);
            cleanData();

            // SweetAlert2 para mostrar éxito
            Swal.fire({
                icon: 'success',
                title: 'El Jefe ha sido registrado con éxito',
                showConfirmButton: false,
                timer: 1500
            });

        } catch (error) {
            if (error.response?.data?.message) {
                return alert(error.response.data.message);
            }
            console.error('Error en saveJefe:', error.message);
        }
    };

    const updateJefe = async () => {
        try {
            const jefeData = {
                nombre1Jefe,
                nombre2Jefe,
                apellido1Jefe,
                apellido2Jefe,
                telefono1Jefe,
                emailJefe
            };

            await axios.put(`/api/jefe/update/${id}`, jefeData);

            Swal.fire('Actualizado', 'El Jefe fue actualizado correctamente.', 'success');
        } catch (error) {
            Swal.fire('Error', error.response?.data?.message || 'Error al actualizar el Jefe.', 'error');
            console.error('Error al actualizar el Jefe:', error);
        }
    };


    const actions = async (e) => {
        e.preventDefault();
        edit ? updateJefe() : saveJefe();
    };


    return (
        <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-2 mb-5 ">
            < div className='container-fluid mt-3' >
                <h1>Registrar Jefes</h1>
            </div>

            <div className='mb-5'>
                
                <form onSubmit={actions}>
                    <div className="container">
                        {/* Fila que contiene dos columnas */}
                        <div className="row d-flex justify-content-between">
                            {/* Columna izquierda: datos del docente */}
                            <div className="col-md-12">
                                {/* Datos del docente */}
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="nombre1" className="form-label  mt-3 mb-2 ">Nombre 1</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="nombre1"
                                            placeholder="Ingrese su primer nombre"
                                            value={nombre1Jefe}
                                            onChange={(e) => setNombre1Jefe(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label htmlFor="nombre2" className="form-label  mt-3 mb-2 ">Nombre 2</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="nombre2"
                                            placeholder="Ingrese su segundo nombre"
                                            value={nombre2Jefe}
                                            onChange={(e) => setNombre2Jefe(e.target.value)}
                                        />
                                    </div>

                                    <div className="col-md-3">
                                        <label htmlFor="apellido1" className="form-label  mt-3 mb-2">Apellido 1</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="apellido1"
                                            placeholder="Ingrese su primer apellido"
                                            value={apellido1Jefe}
                                            onChange={(e) => setApellido1Jefe(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label htmlFor="apellido2" className="form-label  mt-3 mb-2">Apellido 2</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="apellido2"
                                            placeholder="Ingrese su segundo apellido"
                                            value={apellido2Jefe}
                                            onChange={(e) => setApellido2Jefe(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-3">
                                        <label htmlFor="tipoDocumento" className="form-label mt-3 mb-2">Tipo de Documento</label>
                                        <select
                                            className="form-control"
                                            id="tipoDocumento"
                                            value={tipodocumentoJefe}
                                            onChange={(e) => setTipodocumentoJefe(e.target.value)}
                                            required
                                            disabled={edit}   // Deshabilitar en modo edición
                                        >
                                            <option value="">Seleccione un tipo</option>
                                            <option value="CC">Cédula de Ciudadanía</option>
                                            <option value="CE">Cédula de Extranjería</option>
                                            <option value="PAS">Pasaporte</option>
                                        </select>
                                    </div>

                                    <div className="col-md-3">
                                        <label htmlFor="numeroDocumento" className="form-label mt-3 mb-2">Número de Documento</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="numeroDocumento"
                                            placeholder="Ingrese su número de documento"
                                            value={documentoJefe}
                                            onChange={(e) => setDocumentoJefe(e.target.value)}
                                            required
                                            disabled={edit}   // Deshabilitar en modo edición
                                        />
                                    </div>

                                    <div className="col-md-3">
                                        <label htmlFor="telefono1" className="form-label  mt-3 mb-2">Teléfono 1</label>
                                        <input
                                            type="tel"
                                            className="form-control"
                                            id="telefono1"
                                            placeholder="Ingrese su número de teléfono1"
                                            value={telefono1Jefe}
                                            onChange={(e) => setTelefono1Jefe(e.target.value)}
                                            required
                                        />
                                    </div>


                                    <div className="col-md-3">
                                        <label htmlFor="email" className="form-label  mt-3 mb-2">Correo Electrónico</label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            id="email"
                                            placeholder="Ingrese su correo electrónico"
                                            value={emailJefe}
                                            onChange={(e) => setEmailJefe(e.target.value)}
                                            required
                                        />
                                    </div>

                                </div>
                            </div>
                        </div>

                        {/* Botón de envío */}
                        <div className="col-12 mt-4 mb-5">
                            <div className="row g-3">
                                <div className="col-12 col-md-6">
                                    <button type="submit" className="btn btn-success w-100">Enviar</button>
                                </div>
                                <div className="col-12 col-md-6">
                                    <button type="button" className="btn btn-danger w-100" onClick={cleanData}>
                                        Cancelar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

            </div>
        </div>
    )
}

export default RegistrarJefes
